<template>
    <div class="reports-child-planning-mutations">
        <div class="row">
            <div class="col-sm-6">
                <page-title
                    title="Afmeldingen kinderen"
                    icon="activities"
                ></page-title>
            </div>
            <div
                class="col-sm-6 text-end"
                style="padding-top: 12px"
            >
                <date-range-select
                    type="day"
                    :listen-to-date="date"
                    @changeDateRange="changeDate($event.dateStart)"
                ></date-range-select>
                <input
                    type="date"
                    class="form-control d-inline-block w-auto align-middle"
                    :value="date"
                    @change="changeDate($event.target.value)"
                />
            </div>
        </div>
        <div class="form-check form-switch my-3">
            <input
                id="only-with-remark"
                v-model="onlyWithRemark"
                class="form-check-input"
                type="checkbox"
                role="switch"
                @change="loadReportData"
            />
            <label
                class="form-check-label"
                for="only-with-remark"
            >
                Alleen afmeldingen met opmerking
            </label>
        </div>
        <p
            v-if="isLoading"
            class="text-center"
            style="margin: 50px"
        >
            Laden...
        </p>
        <p
            v-else-if="errorMessage"
            class="text-danger"
        >
            {{ errorMessage }}
        </p>
        <p
            v-else-if="rows.length === 0"
            class="text-muted"
        >
            Geen afmeldingen gevonden.
        </p>
        <div v-else>
            <div
                class="panel panel-default card"
                style="margin-bottom: 0; margin-top: 5px"
            >
                <div class="panel-heading card-header">Afmeldingen</div>
            </div>
            <table class="table">
                <thead>
                    <tr>
                        <td>Naam kind</td>
                        <td>Naam groep</td>
                        <td>Opvangdatum</td>
                        <td>Opmerking</td>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, index) in rows"
                        :key="index"
                    >
                        <td>{{ row.child_name }}</td>
                        <td>{{ row.group_name }}</td>
                        <td>{{ formatDate(row.date_mutation) }}</td>
                        <td>{{ row.remark }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
import PageTitle from '@/components/Page-Title'

export default {
    name: 'reports-child-planning-mutations',
    components: {
        DateRangeSelect,
        PageTitle
    },
    data() {
        return {
            date: this.$moment().format('YYYY-MM-DD'),
            onlyWithRemark: true,
            isLoading: false,
            errorMessage: '',
            rows: []
        }
    },
    computed: {
        selectedEstablishment() {
            return this.$store.getters.selectedEstablishment
        },
        selectedIdGroups() {
            const selectedGroups = this.$store.getters.selectedGroups || []
            return selectedGroups.map((group) => group.id)
        }
    },
    watch: {
        selectedEstablishment() {
            this.loadReportData()
        },
        selectedIdGroups() {
            this.loadReportData()
        }
    },
    created() {
        this.loadReportData()
    },
    methods: {
        changeDate(date) {
            if (!date || date === this.date) {
                return
            }
            this.date = date
            this.loadReportData()
        },
        formatDate(date) {
            return this.$moment(date).format('ddd D MMM YYYY')
        },
        async loadReportData() {
            if (!this.selectedEstablishment) {
                return
            }

            this.isLoading = true
            this.errorMessage = ''

            try {
                const response = await this.$request.post('/reports/child-planning-mutations', {
                    ...this.$request.getDeprecatedBodyAuthentication(),
                    data: {
                        id_establishment: this.selectedEstablishment.id,
                        id_groups: this.selectedIdGroups,
                        date: this.date,
                        only_with_remark: this.onlyWithRemark
                    }
                })

                if (response && Array.isArray(response.data)) {
                    this.rows = response.data
                } else {
                    this.rows = []
                    this.errorMessage = 'De rapportage kon niet worden geladen.'
                }
            } catch (error) {
                this.rows = []
                this.errorMessage = 'De rapportage kon niet worden geladen.'
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
